

$('body').on('click', '.avatar-pic-uploader .select-file', function () {
    var uploader = $(this).parents('.avatar-pic-uploader');
    uploader.find('input[type="file"]').trigger('click');
    return false;
});

function updateAvatarProgress(uploader, progress) {
    var circumference = parseFloat(uploader.find('.current-progress').attr('stroke-dasharray'));
    var dashoffset = circumference * (1 - progress / 100);
    uploader.find('.current-progress').css({ strokeDashoffset: dashoffset + '' });
}

$('body').on('change', '.avatar-pic-uploader input[type="file"]', function () {
    var input = $(this);
    var uploader = input.parents('.avatar-pic-uploader');
    var file = input[0].files[0];
    var payload = new FormData();

    payload.append('file', file);
    if (uploader.attr('data-method')) payload.append('_method', uploader.attr('data-method'));
    payload.append('_token', $('meta[name="csrf-token"]').attr('content'));

    // load the file into the avatar image
    var reader = new FileReader();
    reader.onload = function (e) {
        // get the base64 image data
        var imageData = e.target.result;
        uploader.find('img').attr('src', imageData);
    };
    reader.readAsDataURL(file);

    // set the progress to zero
    uploader.addClass('uploading');
    updateAvatarProgress(uploader, 0);
    $.ajax({
        xhr: function () {
            var xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener(
                'progress',
                function (e) {
                    if (e.lengthComputable) {
                        var percentComplete = e.loaded / e.total;
                        percentComplete = Math.round(percentComplete * 100);
                        console.log(percentComplete);
                        updateAvatarProgress(uploader, percentComplete);
                    }
                },
                false
            );
            return xhr;
        },
        type: 'POST',
        url: uploader.attr('data-url'),
        data: payload,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function (data) {
            console.log(data);

            if (!data.success) {
                // set the progress to zero
                updateAvatarProgress(uploader, 0);
                showError('Error', data.message);
                return false;
            }

            uploader.removeClass('uploading');
            uploader
                .find('input[name="' + uploader.attr('data-file') + '"]')
                .val(data.file);
            uploader
                .find('input[name="' + uploader.attr('data-file') + '_file"]')
                .val(data.file_file);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });

    return false;
});